import { useIServiceServiceLabelApi } from "@/hooks/api/useIServiceApi";
import { useGetDivision } from "@/hooks/form-v3/useIServiceDivisionCode";

// 缓存请求中的 Promise，避免重复调用
let labelPromise = null;

// 获取 service label 配置（带缓存）
export const useGetServiceLabel = async () => {
  const { divisionCode } = await useGetDivision();
  if (!divisionCode) {
    return null;
  }

  // 如果已有请求在进行中，直接复用该 Promise
  if (!labelPromise) {
    labelPromise = useIServiceServiceLabelApi({ divisionCode }).then(({ data }) => {
      if (data?.value) {
        return typeof data.value === "string" ? JSON.parse(data.value) : data.value;
      }
      return null;
    });
  }

  return await labelPromise;
};
